<template>
  <div class="sifa-cont-right">
    <div class="personbox">
      <h2>我的参拍</h2>
      <div class="sub-page"></div>
      <div>
        <el-tabs v-if="token&&this.userInfo&&this.userInfo.access_token" v-model="activeName">
          <el-tab-pane label="未开始" name="10">
            <my-bid-table v-if="activeName == 10" :meetingStatus="activeName"></my-bid-table>
          </el-tab-pane>
          <el-tab-pane label="进行中" name="20">
            <my-bid-table v-if="activeName == 20" :meetingStatus="activeName"></my-bid-table>
          </el-tab-pane>
          <el-tab-pane label="已结束" name="30">
            <my-bid-table v-if="activeName == 30" :meetingStatus="activeName"></my-bid-table>
          </el-tab-pane>
          <el-tab-pane label="已成交" name="已成交">
            <my-bid-table :key="activeName" :meetingStatus="activeName"></my-bid-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {getDictionary} from "@/api/system/dictbiz";
import {mapGetters} from "vuex";
import myBidTable from "./myBidTable.vue";
import {getToken} from '@/util/auth'

export default {
  name: 'myBid',
  computed: {
    token() {
      return getToken();
    },
    ...mapGetters(["userInfo"])
  },
  components: {
    myBidTable
  },
  data() {
    return {
      activeName: '10',
      options: [],
      value: '',
      childPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
    }
  },
  created() {
    if (getToken() && this.userInfo && this.userInfo.user_id) {
      this.init();
    } else {
      this.$router.push("/login")
    }
  },
  methods: {
    init() {
      getDictionary({code: 'entrust_way'}).then((res) => {
        this.options = res.data.data;
      })
    },
    entrustWayChange(entrustWay) {
      console.log(1111, entrustWay)
      let params = {
        meetingStatus: this.activeName
      }
      this.$refs.childRef.onLoad(this.childPage, params);
    },
  }
}
</script>

<style>
.personbox {
  margin: 0 0 40px;
  display: none;
  background-color: #fff;
  display: block;
}

.personbox h2 {
  height: 30px;
  line-height: 30px;
  background: #e9e9e9;
  color: #424242;
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
}

.tabDiv {
  margin-top: 20px;
}

.el-tabs__nav-scroll {
  margin-top: 1%;
  margin-left: 5%;
}

.selectWay {
  margin-top: 2%;
  margin-left: 60%;
}
</style>
